
















































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Modal extends Vue {
    @Prop() private type!: string;
    showContent: boolean = false;

    resolve: any = null;
    reject: any = null;
    text: string = "";

    open(text: string) {
        this.text = text;
        this.showContent = true;

        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    agree() {
        this.resolve(true);
        this.showContent = false;
    }
    cancel() {
        this.resolve(false);
        this.showContent = false;
    }
}
